import { useTranslation } from "react-i18next";
import cn from "classnames";

import { Modal, ModalFooter } from "shared/components/Modals/Modal";

import classesModal from "@platformAssets/components/Modal.module.scss";
import classes from "@platformAssets/components/UploadMediaNew.module.scss";

import { ReactComponent as AlertIcon } from "assets/shared/img/alert_rect-safe.svg";

type ErrorModalProps = {
  close: () => void;
  handleContinue: () => void;
};

const ErrorModal: React.FC<ErrorModalProps> = ({
  close,
  handleContinue,
}): JSX.Element => {
  const { t } = useTranslation("uploadMedia");

  return (
    <Modal
      close={close}
      bodyClass={cn(classesModal.mModal, classes.errorModal)}
      isAnimated
    >
      <ModalFooter customClass={classesModal.footerM}>
        <div className={classes.alert}>
          <AlertIcon />
        </div>
        <div className={classes.titleError}>{t("error.title")}</div>
        {(
          t("error.description", {
            returnObjects: true,
          }) as string[]
        ).map((item, index) => (
          <div key={index} className={classes.descriptionError}>
            {item}
          </div>
        ))}
        <button
          className={cn(
            classes.button,
            classes.firstButton,
            classes.buttonCrop
          )}
          onClick={handleContinue}
        >
          {t("error.continue")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ErrorModal;
